var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"page-root pa-0 ma-0",style:({backgroundImage:'url('+_vm.bkImgSrc+')' }),attrs:{"id":"main-container","fluid":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }